import React from 'react';

const AdminModuleContext = React.createContext(null);

export default AdminModuleContext;